import cx from "classnames";
import { RolePermissions } from "modules/company/entities";
import { useMyPermissions } from "modules/my-permissions";
import React, { CSSProperties, FormEvent, useState } from "react";
import { api, CompanyRolePermission } from "shared/api";
import { useApiMethod } from "shared/lib";
import { Button, EntityForm, Error, Input } from "shared/ui";
import styles from "./role-create-form.module.scss";

export interface IRoleCreateForm {
  companySlug: string;
  onSuccess: () => void;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const RoleCreateForm = (props: IRoleCreateForm) => {
  const hasPermission = useMyPermissions(props.companySlug)?.company.roles.write;

  const submit = useApiMethod(api.companyRbac.companyEmployeeRoleCreate);

  const [name, setName] = useState("");
  const [permissions, setPermissions] = useState<Set<CompanyRolePermission>>(() => new Set());

  const valid = !!name.trim();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!valid) return;

    await submit.call(props.companySlug, {
      name,
      permissions: Array.from(permissions),
    });

    setName("");
    setPermissions(new Set());

    await props.onSuccess();
  };

  const tabIndex = hasPermission ? undefined : -1;

  return (
    <form
      className={cx(styles.role_create_form, props.className)}
      style={props.style}
      id={props.htmlId}
      onSubmit={onSubmit}
    >
      <EntityForm
        title="Новая роль"
        footerNote={
          <>
            {submit.error && <Error label={null}>{submit.error.message}</Error>}
            {!hasPermission && "Создавать роли может только владелец компании"}
          </>
        }
        disabled={!hasPermission}
        primaryAction={
          <Button size="small" loading={submit.loading} disabled={!valid} tabIndex={tabIndex}>
            Добавить
          </Button>
        }
      >
        <Input placeholder="Название" value={name} onChange={(e) => setName(e.target.value)} tabIndex={tabIndex} />

        <RolePermissions value={permissions} onChange={setPermissions} className={styles.permissions} />
      </EntityForm>
    </form>
  );
};

RoleCreateForm.defaultProps = {};
